import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { savePaymentMethod } from '../slices/cartSlice.js'

import PaymentMethodSelect, { usePaymentMethod } from '../components/PaymentMethodSelect';

function PaymentScreen() {

    const payment = usePaymentMethod();
    const { paymentMethod } = payment;

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const cart = useSelector((state) => state.cart)
    const { shippingAddress } = cart

    useEffect(() => {
        if (!shippingAddress) {
            navigate('/shipping')
        }
     }, [shippingAddress, navigate])

     function submitHandler(e) {
        e.preventDefault()
        if (!paymentMethod) return;
        dispatch(savePaymentMethod(paymentMethod))
        navigate('/placeorder')
     }

  return (
    <section className='mx-auto w-full max-w-2xl'>
      <div className='rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8'>
        <p className='mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-sky-700'>
          Checkout
        </p>
        <h1 className='mb-6 text-3xl font-semibold text-slate-900'>Payment Method</h1>

        <form onSubmit={submitHandler} className='space-y-5'>
          <PaymentMethodSelect {...payment} />

          <button
            type='submit'
            disabled={!paymentMethod}
            className='inline-flex items-center justify-center rounded-xl bg-sky-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-sky-700'
          >
            Continue
          </button>
        </form>
      </div>
    </section>
  )
}

export default PaymentScreen
